import React, { useEffect, useState } from "react";
import IsRequiredModule from "./IsRequiredModule";
import {
  VWAP_EXIT_CONDITION,
  VWAP_TIMEFRAME_OPTIONS,
} from "../../../../utils/IndicatorUtils";

const getValueOrDefault = (value, fallback) =>
  value !== undefined && value !== null && value !== "" ? String(value) : String(fallback);

const VwapExitSetting = (props) => {
  const { indicator, updateIndicator, isLong, t } = props;
  const [timeframe, setTimeframe] = useState(getValueOrDefault(indicator.value7, 15));
  const [condition, setCondition] = useState(
    getValueOrDefault(indicator.value8, VWAP_EXIT_CONDITION.cross)
  );

  useEffect(() => {
    updateIndicator({
      ...indicator,
      value7: Number(timeframe),
      value8: Number(condition),
    });
  }, [timeframe, condition]);

  useEffect(() => {
    setTimeframe(getValueOrDefault(indicator.value7, 15));
    setCondition(getValueOrDefault(indicator.value8, VWAP_EXIT_CONDITION.cross));
  }, [indicator]);

  return (
    <div>
      <div className="indicator-setting-form above-buy-price above-buy-price2">
        <label className="indicator-setting-label">
          {isLong ? t("long-strategy") : t("short-strategy")}:
        </label>
      </div>

      <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
        <div>
          <label className="indicator-setting-label">{t("vwap-time-frame")}</label>
        </div>
        <div>
          <select
            className="form-control select-normal darker"
            onChange={(e) => {
              setTimeframe(e.target.value);
            }}
            value={timeframe}
          >
            {VWAP_TIMEFRAME_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
        <div>
          <label className="indicator-setting-label">
            {isLong ? t("sell") : t("buy")} {t("vwap-closed-price")}
          </label>
        </div>
        <div>
          <select
            className="form-control select-normal darker"
            onChange={(e) => {
              setCondition(e.target.value);
            }}
            value={condition}
          >
            <option value={VWAP_EXIT_CONDITION.cross}>{t("vwap-exit-cross")}</option>
            <option value={VWAP_EXIT_CONDITION.beyond}>{t("vwap-exit-beyond")}</option>
          </select>
        </div>
      </div>

      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </div>
  );
};

export default VwapExitSetting;
